module.exports = __webpack_public_path__ + "static/media/woody.fe99658b.jpg";